import React, { useState } from 'react';
import { Modal, Form, Input, Select, Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useRequest } from 'ahooks';
import { useGetProductList } from '@/api';
import { uploadFirmware } from '@/api/ota';

interface Props {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const FirmwareModal: React.FC<Props> = ({ open, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [fileList, setFileList] = useState<any[]>([]);
  const { data: products } = useGetProductList({ isAll: true });

  const { loading, run } = useRequest(uploadFirmware, {
    manual: true,
    onSuccess: (resp) => {
      if (resp.success) {
        messageApi.success('上传成功');
        form.resetFields();
        setFileList([]);
        onSuccess();
        onClose();
      } else {
        messageApi.error(resp.errorMsg || '上传失败');
      }
    },
  });

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (!fileList.length) {
        messageApi.error('请选择 .bin 文件');
        return;
      }
      const fd = new FormData();
      fd.append('name', values.name);
      fd.append('version', values.version);
      fd.append('product_id', values.product_id || '');
      fd.append('device_model', values.device_model || '');
      fd.append('description', values.description || '');
      fd.append('file', fileList[0] as File);
      run(fd);
    } catch (e) {
      /* 校验失败，antd 已提示 */
    }
  };

  const beforeUpload = (file: File) => {
    if (!file.name.toLowerCase().endsWith('.bin')) {
      messageApi.error('仅支持 .bin 文件');
      return Upload.LIST_IGNORE;
    }
    setFileList([file]);
    return false; // 阻止自动上传，由表单提交
  };

  return (
    <Modal title="上传固件" open={open} onOk={handleOk} onCancel={onClose} confirmLoading={loading} destroyOnClose>
      {contextHolder}
      <Form form={form} layout="vertical" initialValues={{ product_id: undefined }}>
        <Form.Item name="name" label="固件名称" rules={[{ required: true, message: '请输入固件名称' }]}>
          <Input placeholder="固件名称" />
        </Form.Item>
        <Form.Item name="version" label="版本号" rules={[{ required: true, message: '请输入版本号' }]}>
          <Input placeholder="如 V1.0.0" />
        </Form.Item>
        <Form.Item name="product_id" label="适用产品">
          <Select
            allowClear
            showSearch
            optionFilterProp="label"
            placeholder="选择产品"
            options={(products || []).map((p) => ({ label: p.name, value: p.id }))}
          />
        </Form.Item>
        <Form.Item name="device_model" label="适用设备型号">
          <Input placeholder="设备型号（可选）" />
        </Form.Item>
        <Form.Item name="description" label="说明">
          <Input.TextArea rows={2} placeholder="说明（可选）" />
        </Form.Item>
        <Form.Item label="固件文件">
          <Upload fileList={fileList} beforeUpload={beforeUpload} maxCount={1} accept=".bin">
            <Button icon={<UploadOutlined />}>选择 .bin 文件</Button>
          </Upload>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FirmwareModal;
